module.exports = __webpack_public_path__ + "bf4dac3d2bb670f288747827ece769e2.png";